// Destino del lead del quiz. Módulo aparte, como la medición: quiz.js emite
// quiz:lead y no sabe a dónde va el dato. Cambiar de herramienta es reescribir
// este archivo, no el motor.
//
// QUÉ SE ENVÍA Y POR QUÉ IMPORTA
// La Ley 1581 de 2012 exige poder probar QUÉ texto se autorizó y CUÁNDO. No
// basta un «sí». Por eso el perfil guarda el texto literal del consentimiento
// y su fecha, además del resultado del quiz para poder segmentar después.
//
// El correo NO pasa por el dataLayer (ver quiz-tracking.js). Va directo al
// destino elegido, que es el único autorizado en el texto del consentimiento.

const DESTINOS = {
  /* Probance es el CRM de la tienda. Recibe los contactos igual que el popup
     de boletín del tema (sections/probance-newsletter-popup.liquid): el
     formulario de cliente de Shopify, que crea o marca al cliente como
     suscrito al correo, con etiquetas y los campos PROBANCE_* en la nota.
     Probance sincroniza los clientes de Shopify, así que no abre un flujo de
     datos nuevo. Etiquetas: PROB_QUIZ (origen), quiz-<id> y quiz-rec-<handle>
     para segmentar por quiz y por producto recomendado.
     REVISAR en la tienda: que el envío no pida captcha (Shopify redirige a
     /challenge) y que el cliente aparezca en Probance con sus etiquetas. */
  async probance(lead, extra) {
    const etiquetas = ['PROB_QUIZ', `quiz-${extra.quizId}`, extra.recomendado && `quiz-rec-${extra.recomendado}`]
      .filter(Boolean)
      .join(', ');
    const datos = new URLSearchParams({
      form_type: 'customer',
      utf8: '✓',
      'contact[email]': lead.email,
      'contact[tags]': etiquetas,
      'contact[note][PROBANCE_TAGS]': etiquetas,
      'contact[note][PROBANCE_BEGIN]': '###',
      'contact[note][quiz_id]': extra.quizId || '',
      'contact[note][quiz_recomendado]': extra.recomendado || '',
      'contact[note][quiz_consentimiento_texto]': lead.consent_texto,
      'contact[note][quiz_consentimiento_fecha]': lead.consent_fecha,
      'contact[note][PROBANCE_END]': '###',
    });
    if (lead.nombre) datos.set('contact[first_name]', lead.nombre);
    try {
      const r = await fetch(`${window.Shopify?.routes?.root || '/'}contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: datos,
        credentials: 'same-origin',
      });
      if (!r.ok || /\/challenge/.test(r.url)) {
        console.warn('[quiz] Shopify no aceptó el contacto (posible captcha); el lead no llegó a Probance');
        return false;
      }
      return true;
    } catch (error) {
      console.error('[quiz] no se pudo enviar el lead a Probance:', error);
      return false;
    }
  },

  /* Klaviyo: su app embed sigue en el tema, pero la tienda no lo usa como CRM.
     Se deja como alternativa. Soporta el objeto moderno (klaviyo) y el
     antiguo (_learnq). */
  klaviyo(lead, extra) {
    const perfil = {
      $email: lead.email,
      $first_name: lead.nombre,
      $consent: ['email'],
      quiz_id: extra.quizId,
      quiz_fecha: lead.consent_fecha,
      quiz_consentimiento_texto: lead.consent_texto,
      quiz_recomendado: extra.recomendado || null,
      quiz_respondidas: extra.respondidas || null,
      quiz_respuestas: extra.respuestas || null,
    };

    if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
      window.klaviyo.identify(perfil);
      window.klaviyo.push(['track', 'Quiz completado', { quiz_id: extra.quizId, recomendado: extra.recomendado }]);
      return true;
    }
    if (Array.isArray(window._learnq)) {
      window._learnq.push(['identify', perfil]);
      window._learnq.push(['track', 'Quiz completado', { quiz_id: extra.quizId, recomendado: extra.recomendado }]);
      return true;
    }
    console.warn('[quiz] Klaviyo no está disponible en esta página; el lead no se envió');
    return false;
  },

  /* Backend propio. La opción correcta cuando haga falta lógica o guardar en
     una base de datos bajo control, como sugiere AGENTS.md para datos sensibles. */
  async endpoint(lead, extra) {
    if (!extra.endpoint) {
      console.warn('[quiz] destino «endpoint» sin URL configurada; el lead no se envió');
      return false;
    }
    try {
      const r = await fetch(extra.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...lead, quiz_id: extra.quizId, ...extra }),
      });
      return r.ok;
    } catch (error) {
      console.error('[quiz] no se pudo enviar el lead:', error);
      return false;
    }
  },
};

document.addEventListener('quiz:lead', async (event) => {
  const raiz = event.target.closest('[data-quiz]');
  if (!raiz) return;

  const destino = raiz.dataset.quizLeadDestino || 'ninguno';
  if (destino === 'ninguno') {
    console.warn('[quiz] el lead no tiene destino configurado: el correo se está pidiendo y descartando');
    return;
  }

  const fn = DESTINOS[destino];
  if (!fn) return console.warn('[quiz] destino de lead desconocido:', destino);

  const ok = await fn(event.detail.lead, {
    quizId: event.detail.id,
    endpoint: raiz.dataset.quizLeadEndpoint || '',
    recomendado: event.detail.recomendado || null,
    respondidas: event.detail.respondidas || null,
    respuestas: event.detail.respuestas || null,
  });

  raiz.dispatchEvent(
    new CustomEvent('quiz:lead:enviado', { bubbles: true, detail: { destino, ok } }),
  );
});
